import styled from '@emotion/styled'
import { wrapContained as withStyle, stylesIf } from 'utils/styles'
import { Paragraph } from 'components/patterns'

const SMALL = 178
const MEDIUM = SMALL
const LARGE = 282
const XLARGE = LARGE

const CONTENT_SIZE = {
  SMALL,
  MEDIUM,
  LARGE,
  XLARGE,
}

export default withStyle(
  (props) => `
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: ${CONTENT_SIZE[props.size]}px;
    color: ${props.theme.paragraphColor};
    width: unset !important;
    min-width: 100%;
    ${stylesIf(
      props.isSummaryViewExpanded,
      `
      width: 100%;
    `
    )}
  `
)

export const ModuleMetricsWrapper = styled.div(
  ({ compact }) => `
  display: flex;
  gap: 20px;
  justify-content: center;
  ${stylesIf(
    compact,
    `
    flex-direction: column;
    gap: 6px;
    font-size: 12px;
  `
  )}
`
)

export const LabeledChartStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 62px;
`

export const LabelStyled = styled.div`
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
`

export const DiagnosticVarientLabel = styled.span(
  ({ compact }) => `
  font-weight: bold;
  font-size: 12px;
  ${stylesIf(
    compact,
    `
    font-size: 10px;
  `
  )}
`
)

export const DiagnosticVarient = styled.span(
  ({ compact }) => `
  font-size: 12px;
  font-weight: normal;
  ${stylesIf(
    compact,
    `
    font-size: 10px;
  `
  )}
`
)

export const ModuleTitleWrapper = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
`

export const ModuleNameWrapper = styled.div(
  ({ compact }) => `
  display: flex;
  gap: 8px;
  justify-content: space-between;
  ${stylesIf(
    compact,
    `
    width: 100%;
    align-items: center;
  `
  )}
`
)

export const ModuleName = styled(Paragraph)(
  ({ compact }) => `
  margin-bottom: 0;
  display: flex;
  font-size: 16px;
  ${stylesIf(
    compact,
    `
    font-size: 14px;
  `
  )}
  .tooltip {
    display: flex;
    align-items: center;
  }
`
)

export const Variant = styled(Paragraph)`
  margin-bottom: 0px;
  white-space: nowrap;
`

export const ModuleInfo = styled.div(
  ({ fullWidth }) => `
    display: flex;
    flex-direction: column;
    font-size: 12px;
    justify-content: space-between;
    width: 178px;
    ${stylesIf(
      fullWidth,
      `
      width: 100%;
    `
    )}
  `
)

export const ModuleReferenceOnlyWarning = styled.img(
  () => `
    display: block;
    width: 15px;
    height: 15px;
    margin: 0 3px;
  `
)

export const ModuleSummaryWrapper = styled.div(
  ({ compact }) => `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  ${stylesIf(
    compact,
    `
    gap: 6px;
    `
  )}
`
)

export const ModuleGraphic = styled.div`
  display: flex;
  align-items: center;
`

export const Spacer = styled.div(({ addSpace }) =>
  stylesIf(
    addSpace,
    `
    margin-bottom: 18px
    `
  )
)
